import {
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";

const BadgeIconButton = ({ title, onClick, children, badgeContent = 0, active = false }) => (
  <Tooltip title={title}>
    <IconButton
      size="small"
      onClick={onClick}
      sx={{
        width: 32,
        height: 32,
        borderRadius: "8px",
        border: "1px solid",
        borderColor: active ? "primary.main" : "rgba(0,0,0,0.1)",
        color: active ? "primary.main" : "text.secondary",
        bgcolor: active ? "action.selected" : "background.paper",
        overflow: "visible",
        "&:hover": {
          backgroundColor: "action.hover",
          borderColor: active ? "primary.main" : "rgba(0,0,0,0.18)",
          color: active ? "primary.main" : "text.primary",
        },
      }}
    >
      <Box sx={{ position: "relative", display: "flex", alignItems: "center", overflow: "visible" }}>
        {children}
        {badgeContent > 0 && (
          <Box
            sx={{
              position: "absolute",
              top: -5,
              right: -5,
              width: 14,
              height: 14,
              borderRadius: "50%",
              bgcolor: "primary.main",
              color: "#fff",
              fontSize: 9,
              fontWeight: 600,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1,
              opacity: 0.86,
            }}
          >
            {badgeContent}
          </Box>
        )}
      </Box>
    </IconButton>
  </Tooltip>
);

export default BadgeIconButton;